exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-header[data-v-28fd98f0]{text-align:center}.document-page[data-v-28fd98f0]{margin-top:120px;padding-left:10%;padding-right:10%;padding-bottom:120px}.button-containers[data-v-28fd98f0]{display:flex}.preserve-spaces[data-v-28fd98f0]{flex-grow:1}.doc-page-container[data-v-28fd98f0]{width:100%;position:relative}.doc-field[data-v-28fd98f0]{position:absolute}label.admin-sign-warning[data-v-28fd98f0]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28fd98f0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/documents/SignDocument.vue
// module id = 1036
// module chunks = 2